import React from 'react';
import './Menu.css';
import MenuItem from './MenuItem';
import FoodData from 'Data/Food';
const Menu = () => {
    return (
        <div className="menu-container">
            <h1 className="menu-title">Dinner Menu</h1>
            <ul className="menu-list">
                {
                FoodData.map((foodItem, index) => (
                    <li key={index} className="menu-item">
                        <MenuItem food={foodItem}></MenuItem>
                    </li>
                ))
                }
            </ul>
        </div>
    );
};
export default Menu